import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import makananImg from '../../assets/menu1.jpg';
import minumanImg from '../../assets/menu1.jpg';
import nasiImg from '../../assets/menu1.jpg';
import mieImg from '../../assets/menu1.jpg';

const menuItems = [
  { label: 'ICE BLENDED', path: 'ice-blended', image: makananImg },
  { label: 'SPECIAL DRINK', path: 'special-drink', image: minumanImg },
  { label: 'Coffee & Tea', path: 'coffe-tea', image: nasiImg },
  { label: 'Juice', path: 'juice', image: mieImg },
  { label: 'Other Drink', path: 'other-drink', image: mieImg },
];

const groupItems = (items, itemsPerGroup) => {
  const groups = [];
  for (let i = 0; i < items.length; i += itemsPerGroup) {
    groups.push(items.slice(i, i + itemsPerGroup));
  }
  return groups;
};

const CulinaryCarousel = () => {
  const navigate = useNavigate();
  const [itemsPerSlide, setItemsPerSlide] = useState(5);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const updateItemsPerSlide = () => {
      setItemsPerSlide(window.innerWidth < 768 ? 2 : 5);
    };

    updateItemsPerSlide();
    window.addEventListener('resize', updateItemsPerSlide);
    return () => window.removeEventListener('resize', updateItemsPerSlide);
  }, []);

  const remainder = menuItems.length % itemsPerSlide;
  const paddedItems = [...menuItems];
  if (remainder !== 0) {
    const missing = itemsPerSlide - remainder;
    paddedItems.push(...menuItems.slice(0, missing));
  }

  const groupedItems = groupItems(paddedItems, itemsPerSlide);

  return (
    <div className="bg-pink-700 py-6 md:py-4 text-center text-white pt-28 md:pt-24">
      <h2 className="text-2xl font-bold mb-6">Explore Our Culinary</h2>
      <div className="max-w-6xl mx-auto px-4 relative pb-12">
        <Carousel
          showArrows
          showThumbs={false}
          showStatus={false}
          showIndicators={false}
          infiniteLoop
          autoPlay
          interval={3000}
          stopOnHover={false}
          swipeable
          emulateTouch
          selectedItem={currentSlide}
          onChange={setCurrentSlide}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 text-white hover:text-pink-300 text-3xl"
              >
                ‹
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <button
                type="button"
                onClick={onClickHandler}
                title={label}
                className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 text-white hover:text-pink-300 text-3xl"
              >
                ›
              </button>
            )
          }
        >
          {groupedItems.map((group, index) => (
            <div
              key={index}
              className={`grid ${
                itemsPerSlide === 2 ? 'grid-cols-2 gap-4' : 'grid-cols-5 gap-6'
              } justify-items-center`}
            >
              {group.map((item, idx) => (
                <div
                  key={idx}
                  className="flex flex-col items-center cursor-pointer"
                  onClick={() => navigate(`/drink/${item.path}`)}
                >
                  <img
                    src={item.image}
                    alt={item.label}
                    className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover mb-2 border-2 border-white hover:scale-105 transition-transform"
                  />
                  <p className="text-sm md:text-base text-white font-medium">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          ))}
        </Carousel>

        {/* Custom Indicator */}
        <div className="mt-6 flex justify-center space-x-2">
          {groupedItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                currentSlide === index ? 'bg-white' : 'bg-white/40'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CulinaryCarousel;
